import ky from 'ky'
import Vue from 'vue'

import msalPlugin from '@/plugins/msalPlugin'

const baseUrl = process.env.baseURL || process.env.VUE_APP_API_URL || 'http://localhost:4000'

const _ky = ky.create({
  headers: {
    'content-Type': 'application/json'
  }
})

const api = _ky.extend({
  prefixUrl: baseUrl,
  hooks: {
    beforeRequest: [
      (request, options) => {
        request.headers.set('Authorization', `Bearer ${msalPlugin.data.accessToken}`)
        options.retry = { limit: 2, statusCodes: [401, 500, 503] }
        options.timeout = false
      }
    ],
    beforeRetry: [
      async (_request, _options, response) => {
        await msalPlugin.acquireToken()
      }
    ]
  }
})

const graph = _ky.extend({
  prefixUrl: 'https://graph.microsoft.com/v1.0',
  hooks: {
    beforeRequest: [
      (request, options) => {
        request.headers.set('Authorization', `Bearer ${msalPlugin.data.graphToken}`)
        options.retry = { limit: 2, statusCodes: [401] }
      }
    ],
    beforeRetry: [
      async (_request, _options, response) => {
        await msalPlugin.acquireToken()
      }
    ],
    beforeError: [
      error => {
        // TODO: handle timeouts. Logging as temporary debug output.
        console.log('error :', error)
        return error
      }
    ]
  }
})

const KyPlugin = {
  /**
   * Install function passed to Vue.use()
   *
   * @param Vue
   * @param options
   */
  install (Vue, options) {
    Vue.ky = _ky
    Object.defineProperties(Vue.prototype, {
      ky: {
        get () {
          return _ky
        }
      },
      $api: {
        get () {
          return api
        }
      },
      $graph: {
        get () {
          return graph
        }
      }
    })
  }
}

Vue.use(KyPlugin)

export default KyPlugin
